angular.module('app.filters').filter('brandedAppStatus', function() {
    return function(status) {
        const s = status.replace(/_/g, ' ').replace(/boxcast/gi, 'BoxCast');
        return s.charAt(0).toUpperCase() + s.slice(1);
    };
});


// WEBPACK FOOTER //
// ./filters/branded_app_status.js